
/**
 * objeto para las variables globales
 * de exportZip.ts
 * @type type
 */
window.productAgentList = {

    changeView: function () {
        /**
         * al seleccionar un producto
         * cambia la vista al componente
         * que lista los agentes
         */
    }


};
